export const PAGE_DEFAULT: number = 0;
export const PAGE_LIST_DEFAULT: number = 1;
